import React, { useState } from "react";
import WhatsAppIcon from "./Whatsapp.svg";
import bulb from "./bulb.svg";
import { NavLink } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa6";

function WhatsApp() {
  const [step, setStep] = useState(0);

  const handleIntegrationClick = () => {
    setStep(1);
  };

  const handleNextTip = () => {
    setStep(2);
  };

  const handleNextTip2 = () => {
    setStep(3);
  };

  const handleNextTip3 = () => {
    setStep(4);
  };

  const handleGoBack = () => {
    setStep(0);
  };

  return (

    <div className="bg-gray-200 w-full p-3 relative">
    <NavLink
      to="/integration"
      className="text-indigo-600 text-md text-semibold flex gap-1 items-center mb-3"
    >
      <FaAngleLeft className="text-sm" />
      Go back
    </NavLink>
    <div className="flex flex-col items-start p-4 bg-white w-full rounded">
      <div className="flex items-center mb-6 justify-between">
        <img src={WhatsAppIcon} alt="WhatsApp Icon" />
        <h1 className="text-2xl ms-3 font-semibold">WhatsApp integration</h1>
      </div>
      {step === 0 && (
        <div className="w-2/3">
          <div className="relative flex items-center justify-start mb-6">
            <img
              src="https://www.tidio.com/panel/dist/5f9214017923e28f16dc.png"
              alt="WhatsApp"
              className="w-full"
            />
          </div>
          <div className="text-center">
            <h1 className="text-md font-semibold mb-1">
              Integrate WhatsApp with CausalFunnel
            </h1>
            <p className="text-sm">
              Handle your WhatsApp conversations directly in your CausalFunnel
              inbox and quickly answer your customers' questions. Less
              distraction with switching platforms, more productivity.
            </p>
          </div>
          <div className="flex justify-around w-full mt-8">
            <div className="text-center">
              <p className="text-md font-semibold">Direct messages</p>
              <p className="text-sm text-gray-500">
                Respond to all messages from customers. Group chat and calls are
                not available yet.
              </p>
            </div>
            <div className="text-center">
              <p className="text-md font-semibold">Reply window</p>
              <p className="text-sm text-gray-500">
                You have 24h to reply to messages received from customers.
              </p>
            </div>
            <div className="text-center">
              <p className="text-md font-semibold">Flows</p>
              <p className="text-sm text-gray-500">
                Boost your productivity by adding Flows to automate routine
                conversation.
              </p>
            </div>
          </div>
          <div className="flex justify-center mt-8">
            <button
              className="px-6 py-2 bg-blue-600 text-white rounded"
              onClick={handleIntegrationClick}
            >
              Integrate WhatsApp
            </button>
          </div>
        </div>
      )}
      {step === 1 && (
        <div className="w-2/3">
          <div className="bg-[#FFDDA7] w-10 h-10 flex items-center justify-center rounded mb-4 mt-3">
            <img
              src={bulb}
              alt="Bulb Icon"
              className="h-auto"
              style={{ fill: "#D6892D" }}
            />
          </div>
          <div className="flex items-center mb-2">
            <div>
              <h1 className="text-md font-semibold mb-2">
                WhatsApp integration
              </h1>
              <p className="text-sm mb-2 text-gray-500">
                Before you start, you should prepare a few elements that are
                required to integrate with WhatsApp. Don’t worry, we created a
                list of tips that guide you step by step.
              </p>
            </div>
          </div>

          <h2 className="text-md font-semibold mb-2">What you need</h2>
          <ul className="list-none pl-0" style={{ counterReset: "item" }}>
            <li
              className="text-sm mb-2 before:content-[counter(item)] before:counter-increment-item before:bg-[#DCE9FF] before:text-[#0070f3] before:font-bold before:inline-flex before:items-center before:justify-center before:rounded-full before:w-6 before:h-6 before:mr-2 before:leading-none"
              style={{ counterIncrement: "item" }}
            >
              Access to Facebook Business Manager
            </li>
            <li
              className="text-sm mb-2 before:content-[counter(item)] before:counter-increment-item before:bg-[#DCE9FF] before:text-[#0070f3] before:font-bold before:inline-flex before:items-center before:justify-center before:rounded-full before:w-6 before:h-6 before:mr-2 before:leading-none"
              style={{ counterIncrement: "item" }}
            >
              Phone number for WhatsApp
            </li>
            <li
              className="text-sm mb-2 before:content-[counter(item)] before:counter-increment-item before:bg-[#DCE9FF] before:text-[#0070f3] before:font-bold before:inline-flex before:items-center before:justify-center before:rounded-full before:w-6 before:h-6 before:mr-2 before:leading-none"
              style={{ counterIncrement: "item" }}
            >
              Your business’ legal address and details
            </li>
          </ul>
          <div className="flex justify-between mt-11">
            <button
              className="px-6 py-2 text-black border border-gray-300 rounded-md"
              onClick={handleGoBack}
            >
              Go back
            </button>
            <div className="flex">
              <button className="px-6 py-2 border border-gray-300 text-black rounded-md mr-4">
                Skip tips and start integration
              </button>
              <button
                className="px-6 py-2 bg-blue-600 text-white rounded-md "
                onClick={handleNextTip}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
      {step === 2 && (
        <div className="w-2/3">
          <div className="bg-[#FFDDA7] w-10 h-10 flex items-center justify-center rounded mb-4 mt-3">
            <img
              src={bulb}
              alt="Bulb Icon"
              className="h-auto"
              style={{ fill: "#D6892D" }}
            />
          </div>
          <div className="flex items-center mb-6">
            <div>
              <h1 className="text-sm font-semibold mb-2 text-gray-500">
                TIP 1 OF 3
              </h1>
              <h2 className="text-md font-semibold mb-2">
                Access to Facebook Business Manager
              </h2>
              <p className="text-sm mb-3">
                To initiate the process, you will be required to log in to your
                Facebook account and have access to your company’s Facebook
                Business Manager. Without a proper account, it’s not possible to
                integrate with WhatsApp.
              </p>
              <p className="text-sm mb-4">
                No account?{" "}
                <a
                  href="https://www.facebook.com/business/tools/business-manager"
                  className="text-blue-600"
                >
                  Create a new account
                </a>
                , but remember there are some restrictions for the first 24
                hours.
              </p>
            </div>
          </div>
          <div className="flex justify-between mt-11">
            <button
              className="px-6 py-2 text-black border border-gray-300 rounded-md"
              onClick={handleGoBack}
            >
              Go back
            </button>
            <div className="flex">
              <button className="px-6 py-2 border border-gray-300 text-black rounded-md mr-4">
                Skip tips and start integration
              </button>
              <button
                className="px-6 py-2 bg-blue-600 text-white rounded-md "
                onClick={handleNextTip2}
              >
                Next tip
              </button>
            </div>
          </div>
        </div>
      )}

      {step === 3 && (
        <div className="w-2/3">
          <div className="bg-[#FFDDA7] w-10 h-10 flex items-center justify-center rounded mb-4 mt-3">
            <img
              src={bulb}
              alt="Bulb Icon"
              className="h-auto"
              style={{ fill: "#D6892D" }}
            />
          </div>
          <div className="flex items-center mb-6">
            <div>
              <h1 className="text-sm font-semibold mb-2 text-gray-500">
                TIP 2 OF 3
              </h1>
              <h2 className="text-lg font-semibold mb-2">
                Phone number for WhatsApp
              </h2>
              <div className="text-gray-500">
                <p className="text-sm mb-3">
                  Once you've successfully logged in, you'll be required to
                  provide a phone number for your WhatsApp channel that meets
                  the following specifications:
                </p>
                <ul className="list-disc list-inside pl-2">
                  <li className="text-sm mb-2">
                    The phone number you provide must be registered under your
                    company's ownership. It is essential not to use your
                    personal phone number.
                  </li>
                  <li className="text-sm mb-2">
                    You have the option to utilize a phone number that is
                    already registered with either WhatsApp Messenger or the
                    WhatsApp Business App. However, if you wish to use it, you
                    need to delete the WhatsApp Messenger from your device by
                    following{" "}
                    <a
                      href="https://faq.whatsapp.com/"
                      className="text-blue-600"
                    >
                      these steps
                    </a>
                    .
                  </li>
                  <li className="text-sm mb-2">
                    When proceeding, it is necessary for you to have the
                    capability to receive phone calls or SMS to the provided
                    phone number.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="flex justify-between mt-11">
            <button
              className="px-6 py-2 text-black border border-gray-300 rounded-md"
              onClick={handleGoBack}
            >
              Go back
            </button>
            <div className="flex">
              <button className="px-6 py-2 border border-gray-300 text-black rounded-md mr-4">
                Skip tips and start integration
              </button>
              <button
                className="px-6 py-2 bg-blue-600 text-white rounded-md "
                onClick={handleNextTip3}
              >
                Next tip
              </button>
            </div>
          </div>
        </div>
      )}
      {step === 4 && (
        <div className="w-2/3">
          <div className="bg-[#FFDDA7] w-10 h-10 flex items-center justify-center rounded mb-4 mt-3">
            <img
              src={bulb}
              alt="Bulb Icon"
              className="h-auto"
              style={{ fill: "#D6892D" }}
            />
          </div>
          <div className="flex items-center mb-6">
            <div>
              <h1 className="text-sm font-semibold mb-2 text-gray-500">
                TIP 3 OF 3
              </h1>
              <h2 className="text-lg font-semibold mb-1">
                Details of your business and legal address
              </h2>
              <div className="text-gray-500">
                <p className="text-sm mb-2">
                  During the integration process, it is important to have the
                  following information available during the process:
                </p>
                <ul className="list-disc list-inside pl-3">
                  <li className="text-sm mb-2">
                    Name of your company, which will be visible to the customers
                    you engage in conversations with
                  </li>
                  <li className="text-sm mb-2">
                    Legal business name of your company
                  </li>
                  <li className="text-sm mb-2">
                    Official address of your company
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="flex justify-between mt-11">
            <button
              className="px-6 py-2 text-black border border-gray-300 rounded-md"
              onClick={handleGoBack}
            >
              Go back
            </button>
            <div className="flex">
              <button className="px-6 py-2 border border-gray-300 text-black rounded-md mr-4">
                Skip tips and start integration
              </button>
              <button className="px-6 py-2 bg-blue-600 text-white rounded-md">
                Start integration
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </div>
  );
}

export default WhatsApp;
